// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oK3n7","text":"styles_text__GNbQL","icons":"styles_icons__KkwOu","socialMediaIcon":"styles_socialMediaIcon__ZS5AP"};